module.exports = __webpack_public_path__ + "img/code.5be0840f.png";